import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useReservationBySource, useRevenueBySource } from '../../../services/booking-chart/hooks/useSourceOfBookingV4';
// import EChartsPie3DComponent from './EChartsPie3DComponent';
import PieChartSkeleton from './PieChartSkeleton';
import HighchartsPie3DComponent from './HighchartsPie3DComponent';

interface PieChartV4ComponentProps {
    property_id: string;
    start_date: string;
    end_date: string;
}

const PieChartV4Component: React.FC<PieChartV4ComponentProps> = ({ property_id, start_date, end_date }) => {
    const filters = { property_id, start_date, end_date };

    // Panggil kedua hook secara terpisah
    const { data: reservationData, isFetching: isFetchingReservations } = useReservationBySource({ filters });
    const { data: revenueData, isFetching: isFetchingRevenue } = useRevenueBySource({ filters });

    // Transformasi data agar sesuai dengan props EChartsPie3DComponent
    const formattedReservationData = reservationData?.data.map(item => ({
        name: item.name || 'Unknown',
        value: item.total,
        color: item.color
    })) ?? [];

    const formattedRevenueData = revenueData?.data.map(item => ({
        name: item.name || 'Unknown',
        value: item.revenue,
        color: item.color
    })) ?? [];

    return (
        <div className="charts-section mt-4">
            <Row className="gy-4">
                {/* Chart untuk Number of Reservations */}
                <Col md={6}>
                    {isFetchingReservations ? (
                        <PieChartSkeleton />
                    ) : (
                        // <EChartsPie3DComponent
                        //     title="Number Of Reservations By Source"
                        //     data={formattedReservationData}
                        // />
                        <HighchartsPie3DComponent
                            title="Number Of Reservations By Source"
                            data={formattedReservationData}
                        />
                    )}
                </Col>

                {/* Chart untuk Total Revenue */}
                <Col md={6}>
                    {isFetchingRevenue ? (
                        <PieChartSkeleton />
                    ) : (
                        // <EChartsPie3DComponent
                        //     title="Total Revenue By Source"
                        //     data={formattedRevenueData}
                        // />
                        <HighchartsPie3DComponent
                            title="Total Revenue By Source"
                            data={formattedRevenueData}
                        />
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default PieChartV4Component;